import type { ModuleTransformer } from '../types';
import type { MonthlyOccurrenceFormType } from './MonthlyOccurrenceForm';

export const fromPayload: ModuleTransformer<MonthlyOccurrenceFormType>['fromPayload'] = ({
  lottery,
}) => {
  return {
    startDate: lottery.occurrence.startDate,
    endDate: lottery.occurrence.endDate,
    drawDay: lottery.drawDay,
    drawTime: lottery.drawTime,
  };
};
